'use client';

/**
 * LeadQualifier — Agent 2 v3
 *
 * ✅ HOY FUNCIONA: scoring por comportamiento del sitio (Supabase)
 * ⏳ PENDIENTE: Meta CAPI + Marketing API para señal completa
 *
 * PARA ACTIVAR META CAPI:
 * 1. Pedir a la agencia de medios que en el Pixel 1409934083858660
 *    agreguen al usuario yoolcapiserver (ID: 61575474254282) como analista
 * 2. En business.facebook.com → Configuración → Usuarios del sistema
 *    → yoolcapiserver → Generar token (permisos: ads_management, ads_read)
 * 3. supabase secrets set META_PIXEL_ID=1409934083858660
 *    supabase secrets set META_ACCESS_TOKEN=TOKEN
 * 4. supabase functions deploy meta-capi
 */

import { useState, useEffect } from 'react';
import { toast } from 'sonner';
// Conexión desde las env (REACT_APP_SUPABASE_URL/KEY), como el resto de tadmin.
// Antes estaban hardcodeadas contra divina producción: la pantalla escribía en
// datos reales aunque se entrara por tadmin.dev, y la llave viajaba en el bundle.
import { supabaseUrl as SB_URL, supabaseKey as SB_KEY } from '../../services/supabase/supabaseClient';

const C = {
  cta:'#007D6E', black:'#1A1A1A', navy:'#0E2640', gray1:'#54585A',
  muted:'#8D8D8D', border:'#E0E0E0', grayBg:'#EBEBEB', page:'#F7F7F7',
  success:'#158B5C', error:'#ED4068', white:'#FFFFFF', cyan:'#06B6D4', indigo:'#4F46E5',
};


const sbGet = async p => {
  const r = await fetch(`${SB_URL}/rest/v1/${p}`, { headers:{ apikey:SB_KEY, Authorization:`Bearer ${SB_KEY}` }});
  if (!r.ok) throw new Error(await r.text());
  return r.json();
};

const parseUTM = (url='') => {
  try {
    const u = new URL(url);
    return { source:u.searchParams.get('utm_source'), medium:u.searchParams.get('utm_medium'),
             campaign:u.searchParams.get('utm_campaign'), term:u.searchParams.get('utm_term'),
             fbclid:u.searchParams.get('fbclid') };
  } catch { return {}; }
};

const getReadableErrorMessage = (error) => {
  if (!error) return 'Error desconocido';
  if (typeof error === 'string') return error;
  return error?.message || error?.error?.message || error?.details || 'Error desconocido';
};

const calcEdad = fn => {
  if (!fn) return null;
  const hoy=new Date(), nac=new Date(fn);
  let e=hoy.getFullYear()-nac.getFullYear();
  if (hoy.getMonth()<nac.getMonth()||(hoy.getMonth()===nac.getMonth()&&hoy.getDate()<nac.getDate())) e--;
  return e;
};

const inferFunnel = (nav=[], cots=0) => {
  const r=(nav||[]).map(n=>n.ruta||'');
  if (r.some(x=>x.includes('/confirmar')||x.startsWith('/subscription'))) return 'pago';
  if (r.some(x=>x.startsWith('/contratar'))) return 'contratar';
  if (cots>0) return 'cotizacion';
  return 'simulacion';
};

const SCORE_CFG = {
  Alto: { bg:'#E1F5EE', text:'#0F6E56', border:'#9FE1CB', dot:C.success },
  Medio:{ bg:'#FFF8E1', text:'#7A5A00', border:'#FFD54F', dot:'#F5C400' },
  Bajo: { bg:'#FFF0F3', text:'#8C0022', border:'#FBBAD0', dot:C.error   },
};
const FUNNEL_CFG = {
  pago:      { label:'Llegó a pago',      color:C.success, bg:'#E1F5EE' },
  contratar: { label:'Intentó contratar', color:'#0F6E56', bg:'#E1F5EE' },
  cotizacion:{ label:'Cotizó',            color:'#7A5A00', bg:'#FFF8E1' },
  simulacion:{ label:'Solo simuló',       color:C.gray1,   bg:C.grayBg  },
};

const Chip = ({label,color,bg}) => (
  <span style={{display:'inline-block',background:bg||C.grayBg,color:color||C.gray1,
    fontSize:11,fontWeight:600,padding:'3px 10px',borderRadius:100}}>{label}</span>
);
const KV = ({k,v,vColor}) => (
  <div style={{display:'flex',gap:8,marginBottom:6,fontSize:13}}>
    <span style={{color:C.muted,minWidth:130,flexShrink:0}}>{k}</span>
    <span style={{color:vColor||C.black,fontWeight:500}}>{v||'—'}</span>
  </div>
);
const Panel = ({title,children}) => (
  <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:12,padding:'1rem 1.25rem',marginBottom:10}}>
    <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',color:C.muted,marginBottom:10}}>{title}</div>
    {children}
  </div>
);

function BannerMeta() {
  const [v,setV] = useState(true);
  if (!v) return null;
  return (
    <div style={{background:'#EEF2FF',border:'1px solid #C7D2FE',borderRadius:12,
      padding:'12px 16px',marginBottom:16,display:'flex',gap:12,alignItems:'flex-start'}}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.indigo}
        strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:2}}>
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <div style={{flex:1}}>
        <div style={{fontSize:13,fontWeight:600,color:C.indigo,marginBottom:4}}>
          Modo parcial — solo comportamiento del sitio
        </div>
        <div style={{fontSize:12,color:'#4338CA',lineHeight:1.6}}>
          Para scoring completo: pedir a la agencia de medios que agreguen al usuario{' '}
          <strong>yoolcapiserver</strong> (ID: 61575474254282) como analista del Pixel{' '}
          <strong>1409934083858660</strong>. Luego generar el Access Token en{' '}
          business.facebook.com → Usuarios del sistema → yoolcapiserver → Generar token.
        </div>
      </div>
      <button onClick={()=>setV(false)} style={{background:'none',border:'none',cursor:'pointer',
        color:'#818CF8',padding:0,flexShrink:0,fontSize:16}}>✕</button>
    </div>
  );
}

function SessionRow({s,selected,onClick}) {
  const ds=s.datos_simulacion||{}, tit=ds.datosTitular||{};
  const edad=calcEdad(tit.fechaNacimiento), utm=parseUTM(s.landing_url_raw);
  const funnel=inferFunnel(s.historial_navegacion,s.num_cotizaciones), fc=FUNNEL_CFG[funnel];
  const prima=ds.primaCalculada?.primaUF||s.prima_total_uf, lc=s.lead_captura;
  return (
    <div onClick={onClick} style={{border:`1.5px solid ${selected?C.cta:lc?'#9FE1CB':C.border}`,
      borderRadius:10,padding:'12px 14px',cursor:'pointer',marginBottom:8,transition:'all .15s',
      background:selected?'#E6F5F3':lc?'#F0FBF8':C.white}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
        <Chip label={fc.label} color={fc.color} bg={fc.bg}/>
        {lc && <Chip label="Contacto ✓" color={C.success} bg="#E1F5EE"/>}
        {utm.source && <Chip label={utm.source} color={C.cyan} bg="#E0F7FA"/>}
        {utm.fbclid && <span style={{fontSize:10,color:C.muted,padding:'2px 6px',
          background:'#FFF8E1',borderRadius:100,fontWeight:500}}>fbclid</span>}
        <span style={{fontSize:11,color:C.muted,marginLeft:'auto'}}>
          {new Date(s.created_at).toLocaleDateString('es-CL',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'})}
        </span>
      </div>
      <div style={{display:'flex',gap:14,fontSize:12,color:C.gray1,flexWrap:'wrap'}}>
        {edad!=null && <span>{edad} años · {tit.sexo||'?'} · {tit.prevision?.toUpperCase()||'?'}</span>}
        {prima && <span style={{color:C.cta,fontWeight:600}}>UF {parseFloat(prima).toFixed(2)}/mes</span>}
        <span>{s.num_cotizaciones||0} cotizaciones</span>
        <span>{s.pasos_navegacion} pasos</span>
      </div>
      {lc && (
        <div style={{fontSize:11,color:C.success,marginTop:4,fontWeight:500}}>
          {lc.canal_preferido==='whatsapp'?`WA +56 ${lc.whatsapp}`:lc.email}
          {lc.nombre?` · ${lc.nombre}`:''}
        </div>
      )}
      <div style={{fontSize:11,color:C.muted,marginTop:4,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
        {s.ruta_inicio}{utm.campaign?` · ${utm.campaign}`:''}
      </div>
    </div>
  );
}

export default function LeadQualifier() {
  const [sesiones,setSesiones]=useState([]), [loading,setLoading]=useState(true);
  const [selected,setSelected]=useState(null), [analyzing,setAnalyzing]=useState(false);
  const [analysis,setAnalysis]=useState(null), [filter,setFilter]=useState('all');
  const [analysisError,setAnalysisError]=useState('');

  useEffect(()=>{ load(); },[]);

  async function load() {
    try {
      setLoading(true);
      const rows = await sbGet('sesiones?select=id,canal,ruta_inicio,landing_url_raw,datos_simulacion,historial_navegacion,lead_captura,created_at&datos_simulacion=neq.%7B%7D&order=created_at.desc&limit=60');
      const enriched = await Promise.all((rows||[]).map(async s => {
        try {
          const cots=await sbGet(`cotizaciones?select=id,resumen,plan_id&sesion_id=eq.${s.id}`);
          const best=cots.find(c=>c.resumen?.total?.primaUF)||cots[0];
          return {...s,num_cotizaciones:cots.length,prima_total_uf:best?.resumen?.total?.primaUF||null,
            pasos_navegacion:(s.historial_navegacion||[]).length,_cotizaciones:cots};
        } catch { return {...s,num_cotizaciones:0,pasos_navegacion:(s.historial_navegacion||[]).length,_cotizaciones:[]}; }
      }));
      setSesiones(enriched);
    } catch(e){ toast.error('Error: '+e.message); }
    finally{ setLoading(false); }
  }

  const filtered = sesiones.filter(s => {
    if (filter==='con_contacto') return !!s.lead_captura;
    if (filter==='all') return true;
    return inferFunnel(s.historial_navegacion,s.num_cotizaciones)===filter;
  });

  async function analizar(s) {
    setSelected(s); setAnalysis(null); setAnalysisError(''); setAnalyzing(true);
    const ds=s.datos_simulacion||{}, tit=ds.datosTitular||{};
    const utm=parseUTM(s.landing_url_raw), nav=s.historial_navegacion||[];
    const rutas=nav.map(n=>n.ruta), edad=calcEdad(tit.fechaNacimiento);
    const cots=s._cotizaciones||[], best=cots.find(c=>c.resumen?.total?.primaUF)||cots[0];
    const lc=s.lead_captura;

    const ctx=`SESIÓN — Supabase yooldigital.com
ID: ${s.id} | Fecha: ${new Date(s.created_at).toLocaleString('es-CL')}

ORIGEN:
- Landing: ${s.landing_url_raw}
- UTM source: ${utm.source||'directo'} | medium: ${utm.medium||'—'} | campaign: ${utm.campaign||'—'} | term: ${utm.term||'—'}
- fbclid: ${utm.fbclid?'Sí (Meta Ads)':'No'}

PERFIL:
- Edad: ${edad!=null?`${edad} años`:'desconocida'} | Sexo: ${tit.sexo||'?'} | Previsión: ${tit.prevision?.toUpperCase()||'?'}

SIMULACIÓN:
- Completó: ${ds.planId?'Sí':'No'}
- Prima: ${ds.primaCalculada?.primaUF?`UF ${ds.primaCalculada.primaUF}/mes`:'—'}
- Cargas: ${(ds.cargasFamiliares||[]).length}

CONTACTO VOLUNTARIO:
${lc?`Sí — ${lc.canal_preferido==='whatsapp'?`WhatsApp +56 ${lc.whatsapp}`:lc.email}${lc.nombre?` (${lc.nombre})`:''}
Capturado: ${new Date(lc.capturado_en).toLocaleString('es-CL')}`:'No dejó contacto'}

FUNNEL (${nav.length} pasos):
${rutas.slice(0,15).map((r,i)=>`  ${i+1}. ${r}`).join('\n')}
Etapa máxima: ${inferFunnel(nav,cots.length)} | Cotizaciones: ${cots.length}
Llegó a /contratar: ${rutas.some(r=>r.startsWith('/contratar'))?'Sí':'No'}
Llegó a pago: ${rutas.some(r=>r.startsWith('/subscription'))?'Sí':'No'}
${best?`Prima total cotizada: UF ${best.resumen?.total?.primaUF}/mes`:'Sin cotización guardada'}

META: ${utm.fbclid?'fbclid presente — CAPI activado daría audiencia de origen, ad set y creatividad':'Sin fbclid — orgánico o directo'}
NOTA: Meta CAPI no está activo aún.`;

    const sys=`Lead Qualification Agent de Yool. Analizas comportamiento anónimo de sesiones.
HOY solo tienes datos del sitio. Con Meta CAPI activo también tendrías: audiencia, ad set, señales de intent previas.

SCORING:
- Alto: dejó contacto voluntariamente, O llegó a /contratar o pago, O 3+ cotizaciones y 10+ pasos
- Medio: simuló y cotizó 1-2 veces, 4-9 pasos
- Bajo: solo landing, 0 cotizaciones, 1-3 pasos

PLANES YOOL:
- 50%: UF 200, desde UF 0.32/mes (18-49), UF 0.41 (50-65), UF 0.65 (65-70)
- 60%: UF 300, desde UF 0.51/mes (18-49), UF 0.65 (50-65), UF 0.81 (65-70)
- 70%: UF 350, desde UF 0.66/mes (18-49), UF 0.86 (50-65), UF 1.11 (65-70)

RESPONDE SOLO con JSON válido:
{"score":"Alto"|"Medio"|"Bajo","probabilidad_cierre":número,"etapa_funnel":"pago"|"contratar"|"cotizacion"|"simulacion","tiene_contacto":boolean,"perfil_inferido":{"edad":número|null,"prevision":string,"sexo":string,"tiene_cargas":boolean,"prima_mensual_uf":número|null,"plan_que_simulo":"50%"|"60%"|"70%"|null},"intencion":"Alta"|"Media"|"Baja","razon_abandono_probable":string,"estrategia":"contacto_directo"|"retargeting_suave"|"retargeting_educativo"|"descartar","mensaje_retargeting":string,"señales_clave":[string,string,string],"que_falta_para_mejor_scoring":string,"razonamiento":string}`;

    try {
      const res=await fetch('/api/content-agent/lead-qualifier/analyze',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({system:sys,context:ctx})
      });
      const raw=await res.text();
      let data = {};
      if (raw) {
        try { data = JSON.parse(raw); }
        catch { data = { error: raw }; }
      }
      if (!res.ok || !data?.success) {
        const backendMessage = data?.error || data?.details || raw;
        throw new Error(backendMessage ? `${backendMessage}` : `Error ${res.status}`);
      }
      const text=String(data?.data||'').trim();
      if (!text) {
        throw new Error('El agente no devolvió contenido.');
      }
      const sanitizedText = text.replace(/```json|```/g,'').trim();
      try {
        setAnalysis(JSON.parse(sanitizedText));
      } catch {
        throw new Error(`El agente devolvió un JSON inválido: ${sanitizedText.slice(0, 600)}`);
      }
    } catch(e){
      const message=getReadableErrorMessage(e);
      setAnalysisError(message);
      toast.error('Error del agente: '+message);
    }
    finally{ setAnalyzing(false); }
  }

  const FILTERS=[
    {v:'all',l:'Todas'},{v:'con_contacto',l:'Con contacto'},
    {v:'pago',l:'Llegó a pago'},{v:'contratar',l:'Intentó contratar'},
    {v:'cotizacion',l:'Cotizó'},{v:'simulacion',l:'Solo simuló'},
  ];

  return (
    <div style={{background:C.page,minHeight:'100vh',padding:'2rem 1rem',
      fontFamily:'Inter,-apple-system,BlinkMacSystemFont,system-ui,sans-serif'}}>
      <div style={{maxWidth:1100,margin:'0 auto'}}>

        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:'1.25rem'}}>

          <span style={{background:'#E8EAF6',color:'#283593',fontSize:11,fontWeight:600,
            letterSpacing:'.1em',textTransform:'uppercase',padding:'4px 10px',borderRadius:100}}>
            Agent 2
          </span>
          <span style={{fontSize:11,color:C.muted,background:C.grayBg,padding:'4px 10px',borderRadius:100}}>
            comportamiento · Meta pendiente
          </span>
          <span style={{fontSize:13,color:C.gray1,marginLeft:'auto'}}>Lead Qualification Agent</span>
          <button onClick={load} style={{border:`1.5px solid ${C.border}`,borderRadius:8,
            padding:'6px 12px',fontSize:12,fontWeight:500,color:C.gray1,
            background:C.white,cursor:'pointer',fontFamily:'inherit'}}>Actualizar</button>
        </div>

        <BannerMeta/>

        <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap',alignItems:'center'}}>
          {FILTERS.map(f=>(
            <button key={f.v} onClick={()=>setFilter(f.v)} style={{
              border:`1.5px solid ${filter===f.v?C.cta:C.border}`,borderRadius:100,
              padding:'5px 14px',fontSize:12,fontWeight:500,
              color:filter===f.v?C.cta:C.gray1,background:filter===f.v?'#E6F5F3':C.white,
              cursor:'pointer',fontFamily:'inherit',transition:'all .15s'}}>
              {f.l}
            </button>
          ))}
          <span style={{fontSize:12,color:C.muted}}>{filtered.length} sesión{filtered.length!==1?'es':''}</span>
        </div>

        <div style={{display:'grid',gridTemplateColumns:selected?'380px 1fr':'1fr',gap:16,alignItems:'start'}}>

          <div style={{maxHeight:'calc(100vh - 280px)',overflowY:'auto'}}>
            {loading?(
              <div style={{display:'flex',alignItems:'center',gap:10,color:C.muted,fontSize:14,padding:'2rem 0'}}>
                <div style={{width:16,height:16,borderRadius:'50%',border:`2px solid ${C.border}`,
                  borderTopColor:C.cta,animation:'spin .7s linear infinite'}}/>
                Cargando sesiones...
              </div>
            ):filtered.length===0?(
              <div style={{fontSize:14,color:C.muted,padding:'2rem 0'}}>Sin sesiones con este filtro.</div>
            ):filtered.map(s=>(
              <SessionRow key={s.id} s={s} selected={selected?.id===s.id} onClick={()=>analizar(s)}/>
            ))}
          </div>

          {selected&&(
            <div style={{maxHeight:'calc(100vh - 280px)',overflowY:'auto'}}>
              {analyzing?(
                <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:16,
                  padding:'2rem',display:'flex',flexDirection:'column',
                  alignItems:'center',justifyContent:'center',gap:16,minHeight:300}}>
                  <div style={{width:32,height:32,borderRadius:'50%',border:`3px solid ${C.border}`,
                    borderTopColor:C.cta,animation:'spin .7s linear infinite'}}/>
                  <div style={{fontSize:14,color:C.gray1}}>Analizando comportamiento...</div>
                </div>
              ):analysisError?(
                <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:16,
                  padding:'1.25rem',minHeight:300}}>
                  <div style={{background:'#FFF1F4',border:'1px solid rgba(237,64,104,.2)',borderRadius:12,
                    padding:'14px 16px'}}>
                    <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                      color:C.error,marginBottom:6}}>Error del agente</div>
                    <div style={{fontSize:14,color:C.gray1,lineHeight:1.6}}>{analysisError}</div>
                  </div>
                </div>
              ):analysis?(()=>{
                const cfg=SCORE_CFG[analysis.score]||SCORE_CFG.Medio;
                const fc=FUNNEL_CFG[analysis.etapa_funnel]||FUNNEL_CFG.simulacion;
                const lc=selected.lead_captura;
                const utm=parseUTM(selected.landing_url_raw);
                return (<>
                  {/* Fuentes */}
                  <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:10}}>
                    <span style={{fontSize:10,fontWeight:600,letterSpacing:'.08em',textTransform:'uppercase',
                      padding:'3px 8px',borderRadius:100,background:'#E1F5EE',color:'#0F6E56'}}>Supabase ✓</span>
                    {utm.fbclid&&<span style={{fontSize:10,fontWeight:600,letterSpacing:'.08em',textTransform:'uppercase',
                      padding:'3px 8px',borderRadius:100,background:'#FFF8E1',color:'#7A5A00'}}>fbclid ✓ · Meta CAPI ⏳</span>}
                    {lc&&<span style={{fontSize:10,fontWeight:600,letterSpacing:'.08em',textTransform:'uppercase',
                      padding:'3px 8px',borderRadius:100,background:'#EEF2FF',color:C.indigo}}>Contacto voluntario ✓</span>}
                  </div>

                  {/* Score */}
                  <div style={{background:cfg.bg,border:`1.5px solid ${cfg.border}`,borderRadius:12,
                    padding:'1rem 1.25rem',display:'flex',alignItems:'center',gap:16,marginBottom:10}}>
                    <div style={{width:12,height:12,borderRadius:'50%',background:cfg.dot}}/>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                        color:cfg.text,marginBottom:2}}>Score</div>
                      <div style={{fontSize:24,fontWeight:700,color:cfg.text}}>{analysis.score}</div>
                    </div>
                    <div style={{textAlign:'right',borderLeft:`1px solid ${cfg.border}`,paddingLeft:16}}>
                      <div style={{fontSize:11,color:cfg.text,fontWeight:500}}>Prob. cierre</div>
                      <div style={{fontSize:22,fontWeight:700,color:cfg.text}}>{analysis.probabilidad_cierre}%</div>
                    </div>
                    <div style={{textAlign:'right',borderLeft:`1px solid ${cfg.border}`,paddingLeft:16}}>
                      <div style={{fontSize:11,color:cfg.text,fontWeight:500}}>Intención</div>
                      <div style={{fontSize:18,fontWeight:700,color:cfg.text}}>{analysis.intencion}</div>
                    </div>
                  </div>

                  <div style={{display:'flex',gap:8,marginBottom:10,flexWrap:'wrap'}}>
                    <Chip label={`Etapa: ${fc.label}`} color={fc.color} bg={fc.bg}/>
                    <Chip label={analysis.estrategia?.replace(/_/g,' ')}
                      color={analysis.estrategia==='contacto_directo'?C.success:C.gray1}
                      bg={analysis.estrategia==='contacto_directo'?'#E1F5EE':C.grayBg}/>
                  </div>

                  {/* Contacto disponible */}
                  {lc&&(
                    <div style={{background:'#E1F5EE',border:'1px solid #9FE1CB',borderRadius:12,
                      padding:'1rem 1.25rem',marginBottom:10}}>
                      <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                        color:'#0F6E56',marginBottom:8}}>Contacto disponible</div>
                      <div style={{fontSize:14,fontWeight:600,color:'#0F6E56'}}>
                        {lc.canal_preferido==='whatsapp'?`WhatsApp +56 ${lc.whatsapp}`:lc.email}
                      </div>
                      {lc.nombre&&<div style={{fontSize:13,color:'#0F6E56'}}>{lc.nombre}</div>}
                      <button onClick={()=>{
                        navigator.clipboard.writeText(lc.canal_preferido==='whatsapp'?`+56${lc.whatsapp}`:lc.email);
                        toast.success('Copiado');
                      }} style={{marginTop:8,border:'1px solid #9FE1CB',borderRadius:6,
                        padding:'4px 12px',fontSize:11,fontWeight:500,color:'#0F6E56',
                        background:'transparent',cursor:'pointer',fontFamily:'inherit'}}>
                        Copiar contacto
                      </button>
                    </div>
                  )}

                  <Panel title="Perfil inferido">
                    <KV k="Edad" v={analysis.perfil_inferido?.edad?`${analysis.perfil_inferido.edad} años`:'desconocida'}/>
                    <KV k="Previsión" v={analysis.perfil_inferido?.prevision?.toUpperCase()}/>
                    <KV k="Sexo" v={analysis.perfil_inferido?.sexo}/>
                    <KV k="Cargas" v={analysis.perfil_inferido?.tiene_cargas?'Simuló con cargas':'Sin cargas'}/>
                    <KV k="Prima calculada" v={analysis.perfil_inferido?.prima_mensual_uf?`UF ${analysis.perfil_inferido.prima_mensual_uf}/mes`:'—'} vColor={C.cta}/>
                    <KV k="Plan simulado" v={analysis.perfil_inferido?.plan_que_simulo?`Complementario ${analysis.perfil_inferido.plan_que_simulo}`:'desconocido'}/>
                  </Panel>

                  {analysis.señales_clave?.length>0&&(
                    <Panel title="Señales de comportamiento">
                      {analysis.señales_clave.map((s,i)=>(
                        <div key={i} style={{display:'flex',gap:8,marginBottom:6,fontSize:13}}>
                          <span style={{color:C.cta,fontWeight:700,flexShrink:0}}>·</span>
                          <span style={{color:C.black}}>{s}</span>
                        </div>
                      ))}
                    </Panel>
                  )}

                  <div style={{background:C.navy,borderRadius:12,padding:'1rem 1.25rem',marginBottom:10}}>
                    <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                      color:'rgba(255,255,255,.65)',marginBottom:8}}>Mensaje sugerido</div>
                    <div style={{fontSize:14,lineHeight:1.65,color:C.white}}>{analysis.mensaje_retargeting}</div>
                    <button onClick={()=>{navigator.clipboard.writeText(analysis.mensaje_retargeting);toast.success('Copiado');}}
                      style={{marginTop:10,border:'1px solid rgba(255,255,255,.3)',borderRadius:6,
                        padding:'4px 12px',fontSize:11,fontWeight:500,color:'rgba(255,255,255,.8)',
                        background:'transparent',cursor:'pointer',fontFamily:'inherit'}}>Copiar</button>
                  </div>

                  {analysis.que_falta_para_mejor_scoring&&(
                    <div style={{background:'#EEF2FF',border:'1px solid #C7D2FE',borderRadius:10,
                      padding:'10px 14px',marginBottom:10}}>
                      <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                        color:C.indigo,marginBottom:4}}>Para mejorar este scoring</div>
                      <div style={{fontSize:13,color:'#4338CA',lineHeight:1.6}}>
                        {analysis.que_falta_para_mejor_scoring}
                      </div>
                    </div>
                  )}

                  <div style={{background:C.grayBg,borderRadius:10,padding:'12px 14px'}}>
                    <div style={{fontSize:11,fontWeight:600,letterSpacing:'.1em',textTransform:'uppercase',
                      color:C.muted,marginBottom:6}}>Razonamiento</div>
                    <div style={{fontSize:13,lineHeight:1.65,color:C.gray1}}>{analysis.razonamiento}</div>
                  </div>
                </>);
              })():null}
            </div>
          )}

          {!selected&&!loading&&(
            <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:16,
              padding:'2rem',display:'flex',flexDirection:'column',alignItems:'center',
              justifyContent:'center',gap:12,minHeight:300}}>
              <div style={{width:48,height:48,borderRadius:'50%',background:'#E8EAF6',
                display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#283593"
                  strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                </svg>
              </div>
              <div style={{fontSize:16,fontWeight:500,color:C.gray1}}>Selecciona una sesión</div>
              <div style={{fontSize:13,color:C.muted,textAlign:'center',maxWidth:280}}>
                Sesiones con contacto voluntario aparecen en verde. Las que tienen fbclid vienen de Meta Ads.
              </div>
            </div>
          )}
        </div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:#E0E0E0;border-radius:4px}`}</style>
    </div>
  );
}
